<div *ngIf="isShow" class="mb-5">
  <div class="container d-flex justify-content-between align-items-center mb-4 p-2 ack-page-toolbar">
    <div class="">
      <span style="font-weight: bold; color: #22223B;" [style.font-size]="isMobile ? '14px' : '24px'">Acknowledgement Receipt</span>
    </div>
    <div class="d-flex justify-content-end">
      <button type="button" [ngClass]="{activeLangBtn: currentLang == 'en',inactiveLangBtn: currentLang == 'bn'}"
        class="btn btn-sm" (click)="setLanguage('en')">English</button>
      <button type="button" [ngClass]="{activeLangBtn: currentLang == 'bn',inactiveLangBtn: currentLang == 'en'}"
        class="btn btn-sm" (click)="setLanguage('bn')">Bangla</button>
    </div>
  </div>
  
  <div class="d-flex flex-column align-items-center" *ngIf="currentLang == 'bn'">
    <div class="container return-view-background">
      <div class="row mt-10">
        <div class="col-sm-12">
          <div class="col-md-12 bg-white p-1 border-none print-section ack-slip" id="ack-certificate"
              style="padding-top: 30px !important;">

              <div class="w-100 p-2 mt-1 border-none" style="font-family: Solaiman Lipi">
                <div class="row custom-page-back-width ack-header-block" style=" padding-bottom: 20px;">
                  <div class="d-flex justify-content-between align-items-center w-100 mb-4">
                    <div class="ack-ereturn-logo">
                      <img src="assets\img\logo\eReturn_logo_png.png" alt="Logo" style="width:135px;">
                    </div>
                    <div class="fs-14 text-right ack-form-code"><b>আইটি-১১ছ(২০২৩)</b></div>
                  </div>

                  <div class="col-sm-12 text-center ack-govt-logo">
                    <img class="custom-logo-width" src="assets\img\govt-logo\bd-govt-logo.png" alt="Logo">
                  </div>
                  <div class="col-md-12 m-0 border-none text-center mt-3">
                    <b class="fs-18">
                      গণপ্রজাতন্ত্রী বাংলাদেশ সরকার</b><br><b>জাতীয় রাজস্ব বোর্ড</b><br><b>(আয়কর অফিস)</b><br>
                    <br>
                    <b class="fs-16"><u>আয়কর রিটার্ন প্রাপ্তি স্বীকার পত্র/প্রত্যয়ন পত্র</u></b><br>
                  </div>
                  <div class="col-md-12 border-none mt-2 text-center">
                    <b>করবর্ষ:</b><span class=" ml-1"> {{returnResponse?.assessmentYear |
                      convertNumWithOtherCharsToBn}}</span>
                  </div>
                  <div class="mt-3 col-md-12 text-center">
                    ধারাঃ {{ section?.bnValue }} [{{ section?.bnLabel }}]
                  </div>
                </div>


                <div class="content-container-width d-flex flex-column align-items-start justify-content-center">

                  <div class="pb-1 fs-18">করদাতার নাম:<span
                      class=" ml-1">{{returnResponse?.assesName}}</span></div>
                  <div class="py-0 mt-1 fs-18">জাতীয় পরিচয়পত্র নম্বর/পাসপোর্ট নম্বর:<span
                      class=" ml-1">{{(returnResponse?.smartId && returnResponse?.smartId != '' ?
                    returnResponse?.smartId :
                    returnResponse?.nid ? returnResponse?.nid :
                      returnResponse?.passportNumber) | convertNumWithOtherCharsToBn}}
                    </span> </div>
                  <div class="row py-0 mt-1">
                    <div class="col-sm-12 fs-18 ack-tin-digits">

                      টি আইএন:
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[0]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[1]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[2]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[3]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[4]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[5]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[6]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[7]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[8]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[9]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[10]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigitsBangla[11]"
                        readonly>
                    </div>
                  </div>

                  <div class="d-flex fs-18 mt-2 mb-1 justify-content-between w-100">
                    <div>
                      <span>সার্কেল:</span>
                      <span class="ml-1">{{returnResponse?.circle}}</span>
                    </div>
                    <div>
                      <span>কর অঞ্চল:</span>
                      <span class="ml-1">{{returnResponse?.zone}}</span>
                    </div>
                  </div>
                  <div>
                    <div class="py-0 fs-18">মোট আয়: &nbsp;{{totalAmount | convertNumWithOtherCharsToBn}}&nbsp;টাকা<span
                        class=" ml-1"></span> </div>
                  </div>
                  <div>
                    <div class="py-0 mt-1 fs-18 mb-2">মোট পরিশোধিত কর: &nbsp;{{totalTaxAmount |
                      convertNumWithOtherCharsToBn}}&nbsp;টাকা<span class=" ml-1"></span> </div>
                  </div>
                  <div class="row col-12 mt-2 p-2 ack-register-wrap">
                    <div class="col-12" style="font-size:15px">
                      <div class="row">
                        <div class="col-8 bb bl br bt py-1 fs-18">রিটার্ন রেজিস্টারের ক্রমিক নম্বর</div>
                        <div class="col-4 bt bb br py-1 px-0 text-center fs-18">{{returnResponse?.referenceNo |
                          convertNumWithOtherCharsToBn}}</div>
                      </div>
                      <div class="row">
                        <div class="col-8 bb bl br py-1 fs-18">রিটার্ন রেজিস্টারের ভল্যুম নম্বর</div>
                        <div class="col-4 bb br py-1 px-0 text-center fs-18"></div>
                      </div>
                      <div class="row">
                        <div class="col-8 bb bl br py-1 fs-18">রিটার্ন দাখিলের তারিখ</div>
                        <div class="col-4 bb br py-1 px-0 text-center fs-18">{{returnSubmissionDate |
                          convertNumWithOtherCharsToBn}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-page-back-width">
                <div class="d-flex justify-content-between seal-titles">
                  <div class="fs-18">
                    অফিসের সিলমোহর
                  </div>
                  <div class="fs-18" style="max-width: 50%;">
                    রিটার্ন গ্রহণকারী কর্মকর্তার স্বাক্ষর ও সিল
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4 text-center">
                <qrcode [elementType]="elementType" [qrdata]="taxpayerQRData" [width]="125"
                  [errorCorrectionLevel]="'M'"></qrcode>
              </div>

              <div class="col-12 mt-4 text-center font-weight-bold font-italic fs-16"><b>
                  সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই।
                </b>
              </div>
              <div style="clear: both;"></div>

              <div class="col-sm-12 text-center fs-18 py-5">
                অনলাইনে সনদ প্রাপ্তির জন্য অনুগ্রহপূর্বক <b>"https://etaxnbr.gov.bd"</b> ওয়েবসাইটে ভিজিট করুন
              </div>

              <div class="custom-page-back-width">
                <table class="table table-borderless ack-download-row">
                  <tr>
                    <td class="pl-22"></td>
                    <td class="pl-110">
                      
                      
                      <button type="button"
                        style="float: right !important;margin-top: 6px; margin-right: 14px !important; margin-bottom: 5px !important; width: 95px !important;"
                        class="btn btn-sm bg-white btn-pill rounded-pill btn-outline-dark btn-customize"
                        [printStyle]="{body : {'background': 'white'}}" [useExistingCss]="true"
                        printTitle="{{printTitle}}" printSectionId="ack-certificate" ngxPrint>
                        <i class="fa fa-print mr-1" aria-hidden="true"></i>
                        <b>Download</b></button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column align-items-center" *ngIf="currentLang == 'en'">
    <div class="container return-view-background">
      <div class="row mt-10">
        <div class="col-sm-12">
          <div class="col-md-12 bg-white p-1 border-none print-section ack-slip" id="ack-certificate"
              style="padding-top: 30px !important;">

              <div class="w-100 p-2 mt-1 border-none" style="font-family: Solaiman Lipi">
                <div class="row custom-page-back-width ack-header-block" style=" padding-bottom: 20px;">
                  <div class="d-flex justify-content-between align-items-center w-100 mb-4">
                    <div class="ack-ereturn-logo">
                      <img src="assets\img\logo\eReturn_logo_png.png" alt="Logo" style="width:135px;">
                    </div>
                    <div class="fs-14 text-right ack-form-code"><b>IT-11 Chha (2023)</b></div>
                  </div>
                  
                  <div class="col-sm-12 text-center ack-govt-logo">
                    <img class="custom-logo-width" src="assets\img\govt-logo\bd-govt-logo.png" alt="Logo">
                  </div>
                  <div class="col-md-12 m-0 border-none text-center mt-3">
                    <b class="fs-18">
                      Government of the People’s Republic of Bangladesh</b><br><b>National Board of
                      Revenue</b><br><b>(Income Tax Office)</b><br>
                    <br>
                    <b class="fs-16"><u>Acknowledgement Receipt/Certificate of Return of Income</u></b><br>
                  </div>
                  <div class="col-md-12 border-none mt-2 text-center">
                    <b>Assessment Year:</b><span class=" ml-1"> {{returnResponse?.assessmentYear}}</span>
                  </div>
                  <div class="mt-3 col-md-12 text-center">
                    Section: {{ section?.value }} [{{ section?.label }}]
                  </div>
                </div>


                <div class="content-container-width d-flex flex-column align-items-start justify-content-center">

                  <div class="pb-1 fs-18">Name of the Taxpayer:<span
                      class=" ml-1">{{returnResponse?.assesName}}</span></div>
                  <div class="py-0 mt-1 fs-18">NID / Passport No (if No NID):<span
                      class=" ml-1">{{(returnResponse?.smartId && returnResponse?.smartId != '' ?
                      returnResponse?.smartId :
                      returnResponse?.nid ? returnResponse?.nid :
                      returnResponse?.passportNumber)}}
                    </span> </div>
                  <div class="row py-0 mt-1">
                    <div class="col-sm-12 fs-18 ack-tin-digits">

                      TIN:
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[0]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[1]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[2]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[3]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[4]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[5]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[6]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[7]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[8]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[9]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[10]"
                        readonly>
                      <input class="ml-1 assessment-input-box-len text-center" type="text" [value]="tinDigits[11]"
                        readonly>
                    </div>
                  </div>

                  <div class="d-flex fs-18 mt-2 mb-1 justify-content-between w-100">
                    <div>
                      <span>Circle:</span>
                      <span class="ml-1">{{returnResponse?.circle}}</span>
                    </div>
                    <div>
                      <span>Taxes Zone:</span>
                      <span class="ml-1">{{returnResponse?.zone}}</span>
                    </div>
                  </div>
                  <div>
                    <div class="py-0 fs-18">Total Income Shown: &nbsp;{{totalAmount}}&nbsp;Taka<span
                        class=" ml-1"></span> </div>
                  </div>
                  <div>
                    <div class="py-0 mt-1 fs-18 mb-2">Total Tax Paid: &nbsp;{{totalTaxAmount}}&nbsp;Taka<span
                        class=" ml-1"></span> </div>
                  </div>
                  <div class="row col-12 mt-2 p-2 ack-register-wrap">
                    <div class="col-12" style="font-size:15px">
                      <div class="row">
                        <div class="col-8 bb bl br bt py-1 fs-18">Serial No. of Return Register</div>
                        <div class="col-4 bt bb br py-1 px-0 text-center fs-18">{{returnResponse?.referenceNo}}</div>
                      </div>
                      <div class="row">
                        <div class="col-8 bb bl br py-1 fs-18">Volume No. of Return Register</div>
                        <div class="col-4 bb br py-1 px-0 text-center fs-18"></div>
                      </div>
                      <div class="row">
                        <div class="col-8 bb bl br py-1 fs-18">Date of Return Submission</div>
                        <div class="col-4 bb br py-1 px-0 text-center fs-18">{{returnSubmissionDate}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom-page-back-width">
                <div class="d-flex justify-content-between seal-titles">
                  <div class="fs-18">
                    Seal of Tax Office
                  </div>
                  <div class="fs-18" style="max-width: 50%;">
                    Signature and Seal of the Official Receiving the Return
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4 text-center">
                <qrcode [elementType]="elementType" [qrdata]="taxpayerQRData" [width]="125"
                  [errorCorrectionLevel]="'M'"></qrcode>
              </div>

              <div class="col-12 mt-4 text-center font-weight-bold font-italic fs-16"><b>
                  System generated document. No signature required.
                </b>
              </div>
              <div style="clear: both;"></div>

              <div class="col-sm-12 text-center fs-18 py-5">
                Please Visit: <b>"https://etaxnbr.gov.bd"</b> website to get Income Tax Certificate in Online
              </div>

              <div class="custom-page-back-width">
                <table class="table table-borderless ack-download-row">
                  <tr>
                    <td class="pl-22"></td>
                    <td class="pl-110">
                      
                      
                      <button type="button"
                        style="float: right !important;margin-top: 6px; margin-right: 14px !important; margin-bottom: 5px !important; width: 95px !important;"
                        class="btn btn-sm bg-white btn-pill rounded-pill btn-outline-dark btn-customize"
                        [printStyle]="{body : {'background': 'white'}}" [useExistingCss]="true"
                        printTitle="{{printTitle}}" printSectionId="ack-certificate" ngxPrint>
                        <i class="fa fa-print mr-1" aria-hidden="true"></i>
                        <b>Download</b></button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isShow && isPublicUrl && !isApiLoading" class="ack-empty-state">
  <div class="ack-empty-state__card">
    <div class="ack-empty-state__icon">
      <i class="fa fa-file-text-o" aria-hidden="true"></i>
    </div>
    <h3 class="ack-empty-state__title">No data found for this TIN</h3>
    <p class="ack-empty-state__subtitle">
      We could not find an acknowledgement slip for the provided reference.
    </p>
  </div>
</div>

<ngx-ui-loader></ngx-ui-loader>
